import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PullQuoteBlock}
 */
const PullQuote = ({ quote }) => {
    return (
        <section className='col-padding w-full sm:w-8/9 md:w-3/4'>
            <figure>
                <blockquote>
                    <p className='pl-24 sm:pl-72 type-style-serif-h2 sm:type-style-pull-quote italic underline underline-offset-2'>
                        {quote}
                    </p>
                </blockquote>
            </figure>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PullQuote;
